/**
 * Fork of this GitHub repository: https://github.com/Tajnymag/spayd-js
 * Repository was forked because it contained wrong regex for x-ks (konstanti symbol) 
 */

import PaymentDescription from './PaymentDescription';
import {keyMap} from './Keys';

export default function spayd(paymentDescription: PaymentDescription): string {
	const header = 'SPD*1.0';
	const keys = [];

	for (let [key, value] of Object.entries(paymentDescription)) {
		if (!keyMap[key]) {
			throw 'Was given an unsupported key: ' + key;
		}

		keys.push(new keyMap[key](value));
	}

	return `${header}*${keys.sort().join('*').toUpperCase()}`;
}